"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../../themes/base");
var Link_1 = require("../../Link");
var MenuLinkWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0;\n"], ["\n  margin: ", " 0;\n"])), base_1.spacing().small);
var MenuLink = styled_components_1.default(Link_1.Link)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-weight: bold;\n  font-size: 24px;\n"], ["\n  font-weight: bold;\n  font-size: 24px;\n"])));
var MenuItem = function (_a) {
    var routePath = _a.routePath, children = _a.children, onClick = _a.onClick;
    return (react_1.default.createElement(MenuLinkWrapper, null,
        react_1.default.createElement(MenuLink, { color: base_1.colors.tertiaryText.light, secondaryColor: base_1.colors.tertiaryText.light, href: routePath, textUnderline: false, onClick: onClick }, children)));
};
exports.default = MenuItem;
var templateObject_1, templateObject_2;
//# sourceMappingURL=MenuItem.js.map